// extracted by mini-css-extract-plugin
export default {"appsDownload":"AppsDownload-module--appsDownload--e739f"};